"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workflow_designer_point_model_1 = require("./workflow-designer-point.model");
var workflow_designer_types_1 = require("./workflow-designer.types");
var workflow_designer_point_matrix_model_1 = require("./workflow-designer-point-matrix.model");
var workflow_designer_arrow_path_model_1 = require("./workflow-designer-arrow-path.model");
var WorkflowDesignerActionModel = /** @class */ (function () {
    function WorkflowDesignerActionModel(id, name, description) {
        if (id === void 0) { id = null; }
        if (name === void 0) { name = null; }
        if (description === void 0) { description = null; }
        var _this = this;
        this.id = id;
        this.name = name;
        this.description = description;
        this.type = workflow_designer_types_1.WorkflowDesignerType.ACTION;
        this.edit = false;
        this.hover = false;
        this.offsetX = 0;
        this.offsetY = 0;
        this.snap = 1;
        this.start = false;
        this.beginOrigin = null;
        this.endOrigin = null;
        this.matrix = workflow_designer_point_matrix_model_1.WorkflowDesignerPointsMatrix;
        this.beginPoint = new workflow_designer_point_model_1.WorkflowDesignerPointModel();
        this.endPoint = new workflow_designer_point_model_1.WorkflowDesignerPointModel();
        this.arrowPath = new workflow_designer_arrow_path_model_1.WorkflowDesignerArrowPathModel();
        this.beginPoint.onMove = function (point, viewport) {
            point.attr.nearest = viewport.calculateNearestStatePoint(point.x, point.y);
        };
        this.endPoint.onMove = function (point, viewport) {
            point.attr.nearest = viewport.calculateNearestStatePoint(point.x, point.y);
        };
        this.beginPoint.onDragEnd = function (point, viewport) {
            if (point.attr.nearest) {
                if (viewport.process.states[point.attr.nearest.stateIndex] !== _this.end || point.attr.nearest.matrixIndex !== _this.endOrigin) {
                    _this.begin = viewport.process.states[point.attr.nearest.stateIndex];
                    _this.beginOrigin = point.attr.nearest.matrixIndex;
                }
            }
            setTimeout(function () {
                viewport.selected = _this;
                point.attr.nearest = null;
            }, 0);
        };
        this.endPoint.onDragEnd = function (point, viewport) {
            if (point.attr.nearest) {
                if (_this.begin !== viewport.process.states[point.attr.nearest.stateIndex] || _this.beginOrigin !== point.attr.nearest.matrixIndex) {
                    _this.end = viewport.process.states[point.attr.nearest.stateIndex];
                    _this.endOrigin = point.attr.nearest.matrixIndex;
                }
            }
            setTimeout(function () {
                viewport.selected = _this;
                point.attr.nearest = null;
            }, 0);
        };
    }
    Object.defineProperty(WorkflowDesignerActionModel.prototype, "points", {
        get: function () {
            if (this.begin && this.end) {
                var beginAuto = this.matrix[this.lookDirection(this.begin, this.end)];
                var endAuto = this.matrix[this.lookDirection(this.end, this.begin)];
                var begin = this.beginOrigin !== null ? this.matrix[this.beginOrigin] : beginAuto;
                var end = this.endOrigin !== null ? this.matrix[this.endOrigin] : endAuto;
                var x1 = this.begin.x + this.begin.width * begin.x, y1 = this.begin.y + this.begin.height * begin.y, x2 = this.end.x + this.end.width * end.x, y2 = this.end.y + this.end.height * end.y;
                this.beginPoint.position(x1, y1);
                this.endPoint.position(x2, y2);
                return this.arrowPath.setValues(x1, y1, begin, x2, y2, end).points();
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerActionModel.prototype, "connectionPoints", {
        get: function () {
            return ((this.beginPoint.attr.nearest && this.beginPoint.attr.nearest.x) || this.beginPoint.x) + ',' +
                ((this.beginPoint.attr.nearest && this.beginPoint.attr.nearest.y) || this.beginPoint.y) + ',' +
                ((this.endPoint.attr.nearest && this.endPoint.attr.nearest.x) || this.endPoint.x) + ',' +
                ((this.endPoint.attr.nearest && this.endPoint.attr.nearest.y) || this.endPoint.y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerActionModel.prototype, "movingPoint", {
        get: function () {
            return this.beginPoint.moving || this.endPoint.moving;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerActionModel.prototype, "labelX", {
        get: function () {
            return this.arrowPath.labelX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerActionModel.prototype, "labelY", {
        get: function () {
            return this.arrowPath.labelY;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerActionModel.prototype.calculateAngleDifference = function (a1, a2) {
        var a = Math.abs(a1 - a2);
        return Math.abs((a + 180) % 360 - 180);
    };
    WorkflowDesignerActionModel.prototype.move = function (x, y, snap) {
        if (snap === void 0) { snap = 10; }
        this.snap = snap > 1 ? snap : 1;
        this.offsetX += x;
        this.offsetY += y;
    };
    WorkflowDesignerActionModel.prototype.linkStates = function (begin, end) {
        this.begin = begin;
        this.end = end;
        this.adjustOffset();
        return this;
    };
    WorkflowDesignerActionModel.prototype.setOrigins = function (begin, end) {
        if (begin === void 0) { begin = null; }
        if (end === void 0) { end = null; }
        this.beginOrigin = begin;
        this.endOrigin = end;
        this.adjustOffset();
        return this;
    };
    WorkflowDesignerActionModel.prototype.setFormId = function (id) {
        this.formId = id;
        return this;
    };
    WorkflowDesignerActionModel.prototype.adjustOffset = function () {
        if (this.begin && this.end && this.begin === this.end && !this.offsetX && !this.offsetY) {
            this.offsetX = this.matrix[this.endOrigin || 0].vectorX * this.end.width;
            this.offsetY = this.matrix[this.endOrigin || 0].vectorY * this.end.height;
        }
        return this;
    };
    WorkflowDesignerActionModel.prototype.setStart = function () {
        this.beginPoint.locked = true;
        this.start = true;
        this.type = workflow_designer_types_1.WorkflowDesignerType.ACTION_START;
        return this;
    };
    WorkflowDesignerActionModel.prototype.setEdit = function () {
        this.edit = true;
        return this;
    };
    WorkflowDesignerActionModel.prototype.lookDirection = function (state, state2) {
        var angle = Math.round(Math.atan2(state2.centerX - state.centerX, state.centerY - state2.centerY) / Math.PI * 4);
        var direction = angle >= 0 ? angle : 8 + angle;
        return direction;
    };
    WorkflowDesignerActionModel.prototype.getNearest = function (state, state2) {
        var x, maxDist = 100000, direction = 0;
        for (x = 0; x < 8; x++) {
            var x1 = state.x + state.width * this.matrix[x].x, y1 = state.y + state.height * this.matrix[x].y, dx = x1 - state2.centerX, dy = y1 - state2.centerY, dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < maxDist) {
                maxDist = dist;
                direction = x;
            }
        }
        return direction;
    };
    WorkflowDesignerActionModel.prototype.onEdit = function () {
        return this;
    };
    return WorkflowDesignerActionModel;
}());
exports.WorkflowDesignerActionModel = WorkflowDesignerActionModel;
//# sourceMappingURL=workflow-designer-action.model.js.map